import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DocumentView from "./pages/DocumentView";
import TestPage from "./pages/TestPage";
import NotFound from "./components/NotFound";



const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/test" element={<TestPage />} />
        <Route path="/approve/:encryptedId" element={<DocumentView />} />
        <Route path="/reject/:encryptedId" element={<DocumentView />} />
        <Route path="/view/:encryptedId" element={<DocumentView />} />
        <Route path="/:id" element={<DocumentView />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
